
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30052',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30052",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54202",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7896",
  "hubspot-dlb": "static-2.1828",
  "HubStyleTokens": "static-2.11331",
  "I18n": "static-7.1598",
  "quartz": "static-1.6846",
  "quartz-config": "static-1.624",
  "quartz-core": "static-1.6065",
  "react-dlb": "static-1.75",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.764",
  "enviro": "static-4.416",
  "feedback-shared-ui": "static-1.54189",
  "feedback-utils": "static-1.54193",
  "forms-embed-utils-lib": "static-1.4346",
  "forms-utils-lib": "static-1.12356",
  "foundations-assets": "static-1.4728",
  "foundations-components": "static-1.7687",
  "foundations-theming": "static-1.4296",
  "hub-http": "static-1.6103",
  "hubspot-url-utils": "static-1.4034",
  "HubStyle": "static-2.11639",
  "icons": "static-2.637",
  "immutable": "static-2.76",
  "quick-fetch": "static-1.3818",
  "raven": "static-3.5768",
  "react": "static-7.183",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.69",
  "react-rhumb": "static-1.16538",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5252",
  "react-virtualized": "static-2.96",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.485",
  "tinymce-plugins": "static-1.57132",
  "transmute": "static-2.85",
  "ui-images": "static-2.1124",
  "UIComponents": "static-3.8278",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9522",
  "styled-components": "static-2.87",
  "bend-plugin-trellis-migration": "static-1.3310",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3123",
  "quartz-webpack": "static-1.3070",
  "foundations-theming-specialty": "static-1.2012",
  "property-description-translator": "static-1.3739",
  "HeadJS": "static-2.732",
  "framer-motion": "static-1.69",
  "hs-test-utils-bend-plugin": "static-1.3007",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4209",
  "jasmine-runner": "static-1.6354",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4556",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.521",
  "quartz-head": "static-1.511",
  "quartz-i18n": "static-1.521",
  "quartz-routing": "static-1.276",
  "quartz-test": "static-1.521",
  "quartz-tracking": "static-1.225",
  "ui-fonts": "static-1.593",
  "usage-tracker-container": "static-1.7210",
  "usage-tracker-core": "static-1.7070",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.153",
  "conversations-skeleton-state": "static-1.7133",
  "reference-resolvers": "static-1.8050",
  "sanitize-text": "static-1.8029",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10258",
  "sanitize": "static-1.4357",
  "outpost": "static-1.4081",
  "rpc-client-utils": "static-1.4527",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3956",
  "floating-ui": "static-1.53",
  "hs-story-utils": "static-1.9313",
  "react-aria": "static-1.63",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1475",
  "bend-plugin-foundations-theming": "static-1.2779",
  "foundations-theming-base": "static-1.3281",
  "stylex": "static-1.29",
  "csstype": "static-1.50",
  "ai-components-ui-library": "static-1.8626",
  "atom": "static-1.4954",
  "codemirror": "static-5.92",
  "content-assistance-lib": "static-1.7575",
  "ContentUtils": "static-1.67952",
  "data-token-picker": "static-1.16199",
  "file-manager-components": "static-1.23233",
  "FileManagerCore": "static-1.38732",
  "FileManagerLib": "static-1.38873",
  "frontend-preferences-client": "static-1.7808",
  "hub-http-contrib": "static-1.2927",
  "interframe": "static-3.4647",
  "layout-dnd-components": "static-1.12216",
  "layout-dnd-utils": "static-1.11191",
  "property-translator": "static-1.5294",
  "react-codemirror": "static-1.10508",
  "react-colorpicker": "static-2.10094",
  "reference-resolvers-lite": "static-1.7973",
  "rich-text-lib": "static-1.19628",
  "tinymce-data": "static-1.40103",
  "tinymce-themes": "static-1.55988",
  "ui-addon-emoji-picker": "static-1.9771",
  "ui-addon-sales-email": "static-1.5096",
  "ui-brand-identity-lib": "static-1.14642",
  "bender-build-tools": "static-1.3041",
  "hub-http-shared-msw-handlers": "static-1.9692",
  "hubspotter-http-shared-msw-handlers": "static-1.9690",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "usage-tracker-session-replay": "static-1.4906",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "chirp-fetch": "static-1.1766",
  "chatspot-core": "static-1.20749",
  "copilot-toolkit": "static-1.10790",
  "data-fetching-client": "static-1.9560",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4653",
  "ui-addon-video-player": "static-1.8580",
  "ui-coaching-tips": "static-1.28198",
  "usage-tracker": "static-1.7220",
  "cms-field-types": "static-1.4693",
  "content-icons-ui": "static-1.2191",
  "integrations-lib": "static-1.15712",
  "customer-data-objects": "static-1.7538",
  "apollo-dlb": "static-3.80",
  "apollo-link-hub-http": "static-2.4535",
  "apollo-stack-hubspot": "static-3.83",
  "graphql": "static-1.79",
  "immer": "static-1.33",
  "immerable": "static-1.4037",
  "ui-addon-iframeable": "static-1.8934",
  "video-components-external": "static-1.10875",
  "video-data-lib": "static-1.34533",
  "audio-components": "static-1.5738",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29068",
  "FileManagerImages": "static-1.36384",
  "foundations-components-legacy": "static-1.712",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.522",
  "ui-universal-auth": "static-1.8812",
  "urlinator": "static-1.4416",
  "video-components": "static-1.12878",
  "video-embed": "static-1.35367",
  "ts-schema": "static-1.3983",
  "ContentData": "static-1.68027",
  "layout-data-lib": "static-1.9516",
  "react-dnd-compat": "static-1.4503",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1436",
  "external-options-client-types": "static-1.4063",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6759",
  "hs-promise-utils": "static-1.5479",
  "inbound-db-properties-service-client": "static-1.3750",
  "NamespacedHubStyle": "static-2.8973",
  "growth-onboarding-confetti": "static-1.2956",
  "SharedI18nStrings": "static-1.181",
  "ui-addon-i18n": "static-1.11031",
  "amplitude-session-replay-browser": "static-1.57",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5478",
  "magpie-types": "static-1.4938",
  "simple-logging-lib": "static-1.2935",
  "growth-onboarding-feedback-components": "static-1.6465",
  "flux-actions": "static-1.323",
  "hubspot-apollo-client": "static-1.4763",
  "integrations-error-boundary-lib": "static-1.13127",
  "integrations-tracking-lib": "static-1.5479",
  "laboratory-lib": "static-3.7044",
  "native-integrations-shared-strings": "static-1.7671",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10031",
  "unified-auth": "static-1.326",
  "navigation-messaging": "static-1.6918",
  "content-media-composition-data-lib": "static-1.11835",
  "content-media-compositions": "static-2.15842",
  "idb-keyval": "static-1.41",
  "media-bridge-lib": "static-1.18719",
  "unified-auth-core-lib": "static-1.607",
  "social-insights-client-types": "static-1.21708",
  "advanced-menus-core": "static-1.14945",
  "advanced-menus-lib": "static-1.11911",
  "ExportDialog": "static-6.10273",
  "ui-memberships-settings-lib": "static-1.33705",
  "conditional-properties-service-client": "static-1.3702",
  "crm-pipelines-api-client-types": "static-1.4047",
  "framework-builder-read-service-client": "static-1.3913",
  "framework-data-schema-quick-fetch": "static-1.6664",
  "inbound-db-meta-service-client": "static-1.3494",
  "multi-currency-client-types": "static-1.3594",
  "persist-promise": "static-1.3593",
  "foundations-components-test-utils": "static-1.5170",
  "reactive-lib": "static-1.608",
  "hubspot-apollo-cache": "static-1.222",
  "universal-page-editor-lib": "static-1.2890",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3618",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14944",
  "simple-menus-lib": "static-1.16461",
  "crm-record-cards-service-types": "static-1.3515",
  "location-customization-utils-lib": "static-1.8856",
  "react-flip-move": "static-1.67"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30052",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54202",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7896",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "HubStyleTokens": "/HubStyleTokens/static-2.11331",
  "I18n": "/I18n/static-7.1598",
  "quartz": "/quartz/static-1.6846",
  "quartz-config": "/quartz-config/static-1.624",
  "quartz-core": "/quartz-core/static-1.6065",
  "react-dlb": "/react-dlb/static-1.75",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.764",
  "enviro": "/enviro/static-4.416",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54189",
  "feedback-utils": "/feedback-utils/static-1.54193",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4346",
  "forms-utils-lib": "/forms-utils-lib/static-1.12356",
  "foundations-assets": "/foundations-assets/static-1.4728",
  "foundations-components": "/foundations-components/static-1.7687",
  "foundations-theming": "/foundations-theming/static-1.4296",
  "hub-http": "/hub-http/static-1.6103",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyle": "/HubStyle/static-2.11639",
  "icons": "/icons/static-2.637",
  "immutable": "/immutable/static-2.76",
  "quick-fetch": "/quick-fetch/static-1.3818",
  "raven": "/raven/static-3.5768",
  "react": "/react/static-7.183",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.69",
  "react-rhumb": "/react-rhumb/static-1.16538",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5252",
  "react-virtualized": "/react-virtualized/static-2.96",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tinymce-plugins": "/tinymce-plugins/static-1.57132",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1124",
  "UIComponents": "/UIComponents/static-3.8278",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9522",
  "styled-components": "/styled-components/static-2.87",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3310",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3123",
  "quartz-webpack": "/quartz-webpack/static-1.3070",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2012",
  "property-description-translator": "/property-description-translator/static-1.3739",
  "HeadJS": "/HeadJS/static-2.732",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3007",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4209",
  "jasmine-runner": "/jasmine-runner/static-1.6354",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4556",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.521",
  "quartz-head": "/quartz-head/static-1.511",
  "quartz-i18n": "/quartz-i18n/static-1.521",
  "quartz-routing": "/quartz-routing/static-1.276",
  "quartz-test": "/quartz-test/static-1.521",
  "quartz-tracking": "/quartz-tracking/static-1.225",
  "ui-fonts": "/ui-fonts/static-1.593",
  "usage-tracker-container": "/usage-tracker-container/static-1.7210",
  "usage-tracker-core": "/usage-tracker-core/static-1.7070",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7133",
  "reference-resolvers": "/reference-resolvers/static-1.8050",
  "sanitize-text": "/sanitize-text/static-1.8029",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10258",
  "sanitize": "/sanitize/static-1.4357",
  "outpost": "/outpost/static-1.4081",
  "rpc-client-utils": "/rpc-client-utils/static-1.4527",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3956",
  "floating-ui": "/floating-ui/static-1.53",
  "hs-story-utils": "/hs-story-utils/static-1.9313",
  "react-aria": "/react-aria/static-1.63",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1475",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2779",
  "foundations-theming-base": "/foundations-theming-base/static-1.3281",
  "stylex": "/stylex/static-1.29",
  "csstype": "/csstype/static-1.50",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8626",
  "atom": "/atom/static-1.4954",
  "codemirror": "/codemirror/static-5.92",
  "content-assistance-lib": "/content-assistance-lib/static-1.7575",
  "ContentUtils": "/ContentUtils/static-1.67952",
  "data-token-picker": "/data-token-picker/static-1.16199",
  "file-manager-components": "/file-manager-components/static-1.23233",
  "FileManagerCore": "/FileManagerCore/static-1.38732",
  "FileManagerLib": "/FileManagerLib/static-1.38873",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7808",
  "hub-http-contrib": "/hub-http-contrib/static-1.2927",
  "interframe": "/interframe/static-3.4647",
  "layout-dnd-components": "/layout-dnd-components/static-1.12216",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11191",
  "property-translator": "/property-translator/static-1.5294",
  "react-codemirror": "/react-codemirror/static-1.10508",
  "react-colorpicker": "/react-colorpicker/static-2.10094",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7973",
  "rich-text-lib": "/rich-text-lib/static-1.19628",
  "tinymce-data": "/tinymce-data/static-1.40103",
  "tinymce-themes": "/tinymce-themes/static-1.55988",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9771",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5096",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14642",
  "bender-build-tools": "/bender-build-tools/static-1.3041",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9692",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9690",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4906",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "chirp-fetch": "/chirp-fetch/static-1.1766",
  "chatspot-core": "/chatspot-core/static-1.20749",
  "copilot-toolkit": "/copilot-toolkit/static-1.10790",
  "data-fetching-client": "/data-fetching-client/static-1.9560",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4653",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8580",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28198",
  "usage-tracker": "/usage-tracker/static-1.7220",
  "cms-field-types": "/cms-field-types/static-1.4693",
  "content-icons-ui": "/content-icons-ui/static-1.2191",
  "integrations-lib": "/integrations-lib/static-1.15712",
  "customer-data-objects": "/customer-data-objects/static-1.7538",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4535",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.83",
  "graphql": "/graphql/static-1.79",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4037",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8934",
  "video-components-external": "/video-components-external/static-1.10875",
  "video-data-lib": "/video-data-lib/static-1.34533",
  "audio-components": "/audio-components/static-1.5738",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29068",
  "FileManagerImages": "/FileManagerImages/static-1.36384",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.712",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.522",
  "ui-universal-auth": "/ui-universal-auth/static-1.8812",
  "urlinator": "/urlinator/static-1.4416",
  "video-components": "/video-components/static-1.12878",
  "video-embed": "/video-embed/static-1.35367",
  "ts-schema": "/ts-schema/static-1.3983",
  "ContentData": "/ContentData/static-1.68027",
  "layout-data-lib": "/layout-data-lib/static-1.9516",
  "react-dnd-compat": "/react-dnd-compat/static-1.4503",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1436",
  "external-options-client-types": "/external-options-client-types/static-1.4063",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6759",
  "hs-promise-utils": "/hs-promise-utils/static-1.5479",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3750",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8973",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2956",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11031",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5478",
  "magpie-types": "/magpie-types/static-1.4938",
  "simple-logging-lib": "/simple-logging-lib/static-1.2935",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6465",
  "flux-actions": "/flux-actions/static-1.323",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4763",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13127",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5479",
  "laboratory-lib": "/laboratory-lib/static-3.7044",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7671",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10031",
  "unified-auth": "/unified-auth/static-1.326",
  "navigation-messaging": "/navigation-messaging/static-1.6918",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11835",
  "content-media-compositions": "/content-media-compositions/static-2.15842",
  "idb-keyval": "/idb-keyval/static-1.41",
  "media-bridge-lib": "/media-bridge-lib/static-1.18719",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.607",
  "social-insights-client-types": "/social-insights-client-types/static-1.21708",
  "advanced-menus-core": "/advanced-menus-core/static-1.14945",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11911",
  "ExportDialog": "/ExportDialog/static-6.10273",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33705",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3702",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4047",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3913",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6664",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3494",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3594",
  "persist-promise": "/persist-promise/static-1.3593",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5170",
  "reactive-lib": "/reactive-lib/static-1.608",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.222",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2890",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3618",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14944",
  "simple-menus-lib": "/simple-menus-lib/static-1.16461",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3515",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8856",
  "react-flip-move": "/react-flip-move/static-1.67"
}
};
